/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/crm-fetch-client";
import type { GetContactQueryResponse, GetContactPathParams, GetContactHeaderParams, GetContact401 } from "../../models/contactsController/GetContact";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/crm-fetch-client";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getContactQueryKey = (contactId: GetContactPathParams["contactId"]) => [{ url: '/contacts/:contactId', params: {contactId:contactId} }] as const

export type GetContactQueryKey = ReturnType<typeof getContactQueryKey>

/**
 * {@link /contacts/:contactId}
 */
export async function getContact(contactId: GetContactPathParams["contactId"], headers?: GetContactHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetContactQueryResponse, ResponseErrorConfig<GetContact401>, unknown>({ method : "GET", url : `/contacts/${contactId}`, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function getContactQueryOptions(contactId: GetContactPathParams["contactId"], headers?: GetContactHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getContactQueryKey(contactId)
        return queryOptions<GetContactQueryResponse, ResponseErrorConfig<GetContact401>, GetContactQueryResponse, typeof queryKey>({
         enabled: !!(contactId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getContact(contactId, headers, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * {@link /contacts/:contactId}
 */
export function useGetContact<TData = GetContactQueryResponse, TQueryData = GetContactQueryResponse, TQueryKey extends QueryKey = GetContactQueryKey>(contactId: GetContactPathParams["contactId"], headers?: GetContactHeaderParams, options: 
{
  query?: Partial<QueryObserverOptions<GetContactQueryResponse, ResponseErrorConfig<GetContact401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getContactQueryKey(contactId)
         

         const query = useQuery({
          ...getContactQueryOptions(contactId, headers, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetContact401>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}